import PostSignupView from './PostSignup'
export default PostSignupView
